import React from "react";

const Services = () => {
  return (
    <section className="section fade-in">
      <div className="container">
        <h2>Clinical Services</h2>
        <div className="card">
          <h3>Therapy</h3>
          <p>
            Individual, DBT, and Couple Therapy for emotional well-being and
            relational health.
          </p>
        </div>
        <div className="card" style={{ marginTop: "1rem" }}>
          <h3>Assessments</h3>
          <p>
            Psychodiagnostic and ADHD assessments to support diagnosis and
            treatment planning.
          </p>
        </div>
        <div className="card" style={{ marginTop: "1rem" }}>
          <h3>Consultation & Supervision</h3>
          <p>
            Professional consultation and supervision services for mental health
            practitioners.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;
